import { extend } from 'flarum/common/extend';
import Model from 'flarum/common/Model';
import Discussion from 'flarum/common/models/Discussion';
import app from 'flarum/forum/app';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import { Vnode } from 'mithril';

function find(obj, clazz) {
  if (obj && obj.children) {
    return obj.children.filter(function (e) {
      return (e?.attrs?.className || '').indexOf(clazz) !== -1;
    })[0];
  }
  return undefined;
}

app.initializers.add('bigge-discussion-preview', () => {
  Discussion.prototype.previewText = Model.attribute('previewText');

  extend(DiscussionListItem.prototype, 'view', function (vdom: Vnode) {
    const previewText = this.attrs.discussion?.attribute('previewText') || '';
    const contentElement = find(vdom, 'DiscussionListItem-content');
    const mainElement = find(contentElement, 'DiscussionListItem-main');

    if (mainElement && mainElement.children) {
      const mainChildren = mainElement.children as Vnode[];
      const titleIndex = mainChildren.findIndex((child) => child?.attrs?.className?.includes('DiscussionListItem-title'));

      if (titleIndex !== -1 && previewText) {
        mainChildren.splice(titleIndex + 1, 0, m('div', { className: 'DiscussionListItem-preview' }, previewText));
      }
    }
  });
});
